import {
  Button,
  Col,
  Form,
  Input,
  message,
  PageHeader,
  Radio,
  Row,
  Select,
  TimePicker,
  TreeSelect
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { LeftOutlined } from "@ant-design/icons";
import { addSubscription, getSubScription, updateSubscription, getTeams} from "./api";
import SelectIndex from "./components/SelectIndex";
import CronInput from "./components/CronInput";
import cronstrue from "cronstrue/i18n";
import type {RadioChangeEvent} from 'antd';
import { Base64 } from 'js-base64';

const { useForm } = Form;

const weekOptions = [
  "周一",
  "周二",
  "周三",
  "周四",
  "周五",
  "周六",
  "周日",
].map((item, index) => {
  return (
    <Select.Option value={index + 1 + ""} key={item} style={{ width: 200 }}>
      {item}
    </Select.Option>
  );
});

const dayOptions = new Array(31).fill(1).map((item, index) => {
  return (
    <Select.Option value={index + 1 + ""} key={index} style={{ width: 200 }}>
      {index + 1}日
    </Select.Option>
  );
});

type IndexSubscriptionEditProps = {
  id: number | null;
};

const IndexSubscriptionEdit: React.FC<IndexSubscriptionEditProps> = ({
  id,
}) => {
  const [form] = useForm();
  const [cacheStatus, setCacheStatus] = useState<number>();
  const textRef = useRef<any>(null);

  const onFinish = async () => {
    form
      .validateFields()
      .then((values) => {
        if (values.sendStaffs) {
          values.sendStaffs = values.sendStaffs.join(',');
        }
        if (values.querySql) {
          values.querySql = Base64.encode(values.querySql)
        }
        if (id) {
          // 保存
          updateSubscription(id, { ...values, status: cacheStatus || 0 }).then(
            () => {
              message.success("保存成功");
              window.history.back();
            }
          );
        } else {
          addSubscription(values).then(() => {
            message.success("保存成功");
            window.history.back();
          });
        }
      })
      .catch(() => {
        console.error("请确认输入内容");
      });
  };

  const [teams, setTeams] = useState([]);

  // 刚进入的时候如果有id，就填上
  useEffect(() => {
    getTeams().then((res) => {
      let teamTree:any=[];
      for(const team of res){
        if(team.key == "apis/*"){
          continue;
        }
        const builtTeam = buildTeamTree(team);
        teamTree = [...teamTree, builtTeam];
      }
      setTeams(teamTree);
    })
    if (id && form) {
      getSubScription(id).then((res) => {
        form.setFieldsValue({
          name: res.name,
          sendUrl: res.sendUrl,
          projectGroupName: res.projectGroupName,
          cronExp: res.cronExp,
          contentTemplate: res.contentTemplate,
          sendTarget: res.sendTarget,
          sendStaffs: res.sendStaffs?.split(","),
          sendDataType: res.sendDataType,
          querySql: res.querySql,
        });
        setCacheStatus(res.status);
        setSendTime(form.getFieldValue("cronExp"));
        setSendTarget(form.getFieldValue("sendTarget"));
        setSendStaffs(form.getFieldValue("sendStaffs"));
        setSendDataType(form.getFieldValue("sendDataType"));
      });
    }
  }, [id, form]);

  const onAddIndex = (content: string) => {
    const beforeVal = form.getFieldValue("contentTemplate") || "";
    let start = textRef.current?.resizableTextArea?.textArea?.selectionStart;
    let end = textRef.current?.resizableTextArea?.textArea?.selectionEnd;
    if (start === undefined) {
      start = beforeVal.length;
    }
    if (end === undefined) {
      end = beforeVal.length;
    }
    const target =
      beforeVal.substring(0, start) +
      `\{${content}}` +
      beforeVal.substring(end);
    form.setFieldsValue({
      contentTemplate: target,
    });
  };

  const [sendTime, setSendTime] = useState();

  const onChangeValues = (c, v) => {
    if (c.cronExp !== undefined) {
      setSendTime(c.cronExp);
    } else {
      setSendTime(undefined);
    }
  };

  const [sendTarget, setSendTarget] = useState();
  const onChangeSendTarget = (e: RadioChangeEvent) => {
    setSendTarget(e.target.value);
  };

  const [sendStaffs, setSendStaffs] = useState<string>();
  const onChangeSendStaffs = (newValue) => {
    setSendStaffs(newValue.join(","));
  };

  const [sendDataType, setSendDataType] = useState();
  const onChangeSendDataType = (e: RadioChangeEvent) => {
    setSendDataType(e.target.value);
  };

  return (
    <>
      <PageHeader
        backIcon={
          <>
            <LeftOutlined style={{ color: "skyblue" }} />
            <span style={{ color: "skyblue" }}>返回</span>
          </>
        }
        onBack={() => window.history.back()}
        title={
          <span style={{ fontSize: "16px" }}>
            {id ? "编辑" : "新建"}订阅任务
          </span>
        }
        style={{
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
          marginBottom: "25px",
          marginTop: "-10px",
        }}
      />
      <Row>
        <Col span={12}>
          <Form
            name="basic"
            labelCol={{ span: 4 }}
            // wrapperCol={{ span: 20 }}
            initialValues={{ remember: true }}
            autoComplete="off"
            form={form}
            onValuesChange={onChangeValues}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  label="任务名称"
                  name="name"
                  rules={[{ required: true, message: "请输入任务名称" }]}
                  // wrapperCol={{ span: 10 }}
                >
                  <Input placeholder="请输入任务名称" />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item label="发送时间" required={true}>
              <Form.Item
                trigger="setValue"
                name="cronExp"
                rules={[{ required: true, message: "请选择发送时间" }]}
                style={{ marginBottom: "10px" }}
              >
                <CronInput />
              </Form.Item>
              <div>
                {sendTime
                  ? cronstrue.toString(sendTime, { locale: "zh_CN" })
                  : "-"}
              </div>
            </Form.Item>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="sendTarget"
                  label="发送对象"
                  rules={[{ required: true, message: "请选择发送对象" }]}
                >
                  <Radio.Group onChange={onChangeSendTarget} value={sendTarget}>
                    <Radio value={1}>企微机器人</Radio>
                    <Radio value={2}>企微个人</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
            {sendTarget == 1 &&
            <Row>
              <Col span={24}>
                <Form.Item
                  name="sendUrl"
                  label="机器人地址"
                  rules={[{ required: true, message: "请输入机器人地址" }]}
                >
                  <Input placeholder="单行输入"></Input>
                </Form.Item>
              </Col>
            </Row>}

            {sendTarget == 2 &&
            <Row>
              <Col span={24}>
                <Form.Item
                  name="sendStaffs"
                  label="接收人"
                  rules={[{ required: true, message: "请选择接收人" }]}
                >
                  <TreeSelect
                      showSearch
                      style={{ width: '100%' }}
                      value={sendStaffs}
                      treeCheckable={true}
                      // showCheckedStrategy= {'SHOW_PARENT'}
                      // dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                      placeholder="请选择接收人"
                      allowClear
                      multiple
                      onChange={onChangeSendStaffs}
                      treeData={teams}
                    />
                </Form.Item>
              </Col>
            </Row>}

            <Row>
              <Col span={24}>
                <Form.Item
                  name="sendDataType"
                  label="发送数据类型"
                  rules={[{ required: true, message: "请选择发送数据类型" }]}
                >
                  <Radio.Group onChange={onChangeSendDataType} value={sendDataType}>
                    <Radio value={1}>指标数据</Radio>
                    <Radio value={2}>明细数据</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>

            {sendDataType == 1 && <Row>
              <Col span={24}>
                <Form.Item
                  name="contentTemplate"
                  label="发送内容"
                  rules={[{ required: true, message: "请输入内容" }]}
                >
                  <Input.TextArea
                    ref={textRef}
                    autoSize={{ minRows: 10 }}
                    placeholder="发送内容"
                  ></Input.TextArea>
                </Form.Item>
              </Col>
            </Row>}

            {sendDataType == 2 && <Row>
              <Col span={24}>
                <Form.Item
                  name="querySql"
                  label="查询SQL"
                  rules={[{ required: true, message: "请输入查询SQL" }]}
                >
                  <Input.TextArea
                    ref={textRef}
                    autoSize={{ minRows: 10 }}
                    placeholder="请输入查询SQL"
                  ></Input.TextArea>
                </Form.Item>
              </Col>
            </Row>}

            <Row>
              <Col offset={3} span={15}>
                <Form.Item>
                  <Button type="primary" onClick={onFinish}>
                    保存任务
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col span={8} offset={1} style={{ paddingTop: "50px" }}>
          <SelectIndex onAdd={onAddIndex} />
        </Col>
      </Row>
    </>
  );
};

export default IndexSubscriptionEdit;

export const SendTimeSelector = () => {
  const [sendType, setSendType] = useState("");
  const changeSendType = (e: string) => {
    setSendType(e);
  };

  return (
    <Row>
      <Col span={24}>
        <Form.Item label="发送时间" required>
          <Row>
            <Col span={4}>
              <Form.Item
                name={["sendTime", "type"]}
                initialValue="hour"
                rules={[{ required: true, message: "请选择发送周期" }]}
              >
                <Select value={sendType} onChange={changeSendType}>
                  <Select.Option value="hour" style={{ width: 200 }}>
                    每小时
                  </Select.Option>
                  <Select.Option value="day" style={{ width: 200 }}>
                    每天
                  </Select.Option>
                  <Select.Option value="week" style={{ width: 200 }}>
                    每周
                  </Select.Option>
                  <Select.Option value="month" style={{ width: 200 }}>
                    每月
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>
            {/* 每周选择周几 */}
            {sendType === "week" && (
              <Col span={4}>
                <Form.Item
                  name={["sendTime", "week"]}
                  rules={[{ required: true, message: "请选择星期" }]}
                  initialValue="1"
                >
                  <Select>{weekOptions}</Select>
                </Form.Item>
              </Col>
            )}
            {/* 每月选择日期 */}
            {sendType === "month" && (
              <Col span={4}>
                <Form.Item
                  name={["sendTime", "day"]}
                  rules={[{ required: true, message: "请选择日期" }]}
                  initialValue="1"
                >
                  <Select>{dayOptions}</Select>
                </Form.Item>
              </Col>
            )}
            {/* 每周/每月/每天选择时间 */}
            {["day", "week", "month"].indexOf(sendType) !== -1 && (
              <Col span={4}>
                <Form.Item
                  name={["sendTime", "time"]}
                  rules={[{ required: true, message: "请选择时间" }]}
                >
                  <TimePicker format="HH:mm"></TimePicker>
                </Form.Item>
              </Col>
            )}
          </Row>
        </Form.Item>
      </Col>
    </Row>
  );
};
function buildTeamTree(team) {
  team.value = team.key;
  if(!team.leaf){
    for (const node of team.children) {
      buildTeamTree(node);
  }
  }
  return team;
}

